import React from 'react';
import { Table } from 'antd';
import { Eye, Trophy, UserX } from 'lucide-react';
import { StatusTag, IconAction, IconActions, EmptyState } from '../../../common';
import { t } from '../../../../company/labels';

// Podium colors for the top 3 (gold / silver / bronze).
const PODIUM = ['text-warning-solid', 'text-surface-400', 'text-warning-fg'];

const channelTag = (channel) => <StatusTag tone={channel === 'moderno' ? 'info' : 'warning'}>{channel === 'moderno' ? 'MODERNO' : 'TRADICIONAL'}</StatusTag>;

function TopPromotorsTable({ promotors, loading, navigateToPromoter }) {
    const columns = [
        {
            title: '#',
            key: 'rank',
            width: 64,
            render: (_, __, index) => (
                <div className="flex items-center gap-1.5 tabular-nums">
                    {index < 3 ? <Trophy className={`text-[14px] ${PODIUM[index]}`} /> : <span className="w-[14px]" />}
                    <span className="font-medium text-surface-700">{index + 1}</span>
                </div>
            )
        },
        {
            title: t('promotor'),
            dataIndex: 'name',
            key: 'name',
            render: (name, record) => (
                <div className="min-w-0">
                    <p className="m-0 text-sm font-medium text-surface-900">{name}</p>
                    <p className="m-0 text-xs text-surface-500">{record.email}</p>
                </div>
            )
        },
        {
            title: 'Canal',
            dataIndex: 'channel',
            key: 'channel',
            render: channelTag
        },
        {
            title: 'Tiendas Asignadas',
            dataIndex: 'totalAssignedStores',
            key: 'totalAssignedStores',
            align: 'right',
            render: (count) => <span className="font-medium text-surface-700 tabular-nums">{count || 0}</span>
        },
        {
            title: 'Completadas',
            dataIndex: 'completedStoreChecks',
            key: 'completedStoreChecks',
            align: 'right',
            render: (count) => <span className="font-medium text-success-fg tabular-nums">{count || 0}</span>
        },
        {
            title: 'Cumplimiento',
            dataIndex: 'completionRate',
            key: 'completionRate',
            align: 'right',
            render: (rate) => {
                const tone = rate >= 80 ? 'success' : rate >= 60 ? 'warning' : 'danger';
                return (
                    <StatusTag tone={tone} className="tabular-nums">
                        {rate?.toFixed(1) || 0}%
                    </StatusTag>
                );
            }
        },
        {
            title: 'Acciones',
            key: 'actions',
            align: 'right',
            render: (_, record) => (
                <IconActions>
                    <IconAction icon={<Eye />} label="Ver Detalle" onClick={() => navigateToPromoter(record._id)} />
                </IconActions>
            )
        }
    ];

    return (
        <Table
            columns={columns}
            dataSource={promotors}
            loading={loading}
            rowKey="_id"
            size="middle"
            pagination={false}
            locale={{
                emptyText: <EmptyState icon={<UserX />} title={`No hay ${t('promotoresLower')} activos en este período`} />
            }}
            scroll={{ x: 800 }}
        />
    );
}

export { channelTag };
export default TopPromotorsTable;
